<script lang="ts" setup>
import UdacapiLogo from '../components/UdacapiLogo.vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const { t } = useI18n()
const currentYear = new Date().getFullYear()
</script>

<template>
  <div class="flex flex-col justify-between h-screen items-center bg-[var(--va-background-primary)] font-sans">
    <RouterLink to="/">
      <UdacapiLogo :gradient="true" class="my-8 h-8 drop-shadow-sm" />
    </RouterLink>

    <div class="flex flex-col items-center justify-center flex-1 w-full max-w-2xl px-4 text-center -mt-16">
      <h1
        class="text-[10rem] sm:text-[14rem] font-extrabold leading-none text-transparent bg-clip-text bg-gradient-to-br from-[var(--va-primary)] to-[var(--va-danger)] opacity-90 drop-shadow-md mb-2"
      >
        {{ t('pageNotFound.subtitle') }}
      </h1>
      <h2 class="va-h2 mb-4 tracking-tight">{{ t('pageNotFound.title') }}</h2>

      <p class="text-[var(--va-secondary)] text-lg mb-10 max-w-md mx-auto leading-relaxed">
        {{ t('pageNotFound.description') }}
      </p>

      <div class="flex flex-col sm:flex-row gap-4 justify-center w-full sm:w-auto">
        <VaButton preset="secondary" icon="arrow_back" size="large" class="w-full sm:w-auto" @click="router.back()">
          {{ t('pageNotFound.goBack') }}
        </VaButton>
        <VaButton to="/" icon="home" size="large" class="w-full sm:w-auto shadow-lg hover:shadow-xl transition-shadow">
          {{ t('pageNotFound.goHome') }}
        </VaButton>
      </div>
    </div>

    <div class="pb-8 text-sm text-[var(--va-secondary)] opacity-70">
      {{ t('pageNotFound.copyright', { year: currentYear }) }}
    </div>
  </div>
</template>

<style scoped>
/* No additional styles needed, using Vuestic specific css variables inside Tailwind classes */
</style>
